const SvgInterval = (props) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <path d="M11.693 1.6A7.875 7.875 0 1 1 1.6 6.307" stroke="currentColor" />
      <path
        d="M9 9L5.625 5.062"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth={1.5}
      />
      <circle cx={9} cy={1.125} fill="currentColor" r={1.125} />
    </g>
  </svg>
)

export default SvgInterval
